import MM1group from './components/posts/23-24/pictures/MM1group.jpg';
import MM1officer from './components/posts/23-24/pictures/MM1officer.jpg';
import Uberofficer from './components/posts/23-24/pictures/Uberofficer.jpg';
import Uberspeakers from './components/posts/23-24/pictures/Uberspeakers.jpg';
import Pinterest1 from './components/posts/23-24/pictures/Pinterest1.png';
import Pinterest2 from './components/posts/23-24/pictures/Pinterest2.png';
import Googlerecap1 from './components/posts/23-24/pictures/Googlerecap1.jpg';
import Googlerecap6 from './components/posts/23-24/pictures/Googlerecap6.jpg';
import ghc3 from './components/posts/23-24/pictures/ghc3.jpg';
import ghc1 from './components/posts/23-24/pictures/ghc1.jpg';
import f1 from './components/posts/23-24/pictures/f1.jpg';
import f3 from './components/posts/23-24/pictures/f3.jpg';
import dec1 from './components/posts/23-24/pictures/dec1.jpg';
import dec7 from './components/posts/23-24/pictures/dec7.jpg';
import slumber2 from './components/posts/23-24/pictures/slumber2.jpg';
import slumber6 from './components/posts/23-24/pictures/slumber6.jpg';
import wad1 from './components/posts/23-24/pictures/wad1.jpg';
import wad2 from './components/posts/23-24/pictures/wad2.jpg';

import PM1 from './posts/22-23/pictures/PM1.JPG';
import PM2 from './posts/22-23/pictures/PM2.JPG';
import PM3 from './posts/22-23/pictures/PM3.JPG';
import PM4 from './posts/22-23/pictures/PM4.JPG';
import bouquet1 from './posts/22-23/pictures/bouquet1.jpg';
import bouquet2 from './posts/22-23/pictures/bouquet2.jpg';
import bouquet3 from './posts/22-23/pictures/bouquet3.jpg';
import bouquet4 from './posts/22-23/pictures/bouquet4.jpg';
import bouquet5 from './posts/22-23/pictures/bouquet5.jpg';
import bouquet6 from './posts/22-23/pictures/bouquet6.jpg';
import prep1 from './posts/22-23/pictures/prep1.jpeg';
import prep2 from './posts/22-23/pictures/prep2.jpeg';
import wir1 from './posts/22-23/pictures/wir1.JPG';
import wir2 from './posts/22-23/pictures/wir2.JPG';
import wir3 from './posts/22-23/pictures/wir3.JPG';
import wad from './posts/22-23/pictures/wad.jpg';
import equity1 from './posts/22-23/pictures/equity1.jpg';
import equity2 from './posts/22-23/pictures/equity2.jpg';
import bowl1 from './posts/22-23/pictures/bowl1.jpg';
import bowl2 from './posts/22-23/pictures/bowl2.jpg';
import bowl3 from './posts/22-23/pictures/bowl3.jpg';
import cookies1 from './posts/22-23/pictures/cookies1.jpg';
import cookies2 from './posts/22-23/pictures/cookies2.jpg';
import google1 from './posts/22-23/pictures/google1.JPG';
import google2 from './posts/22-23/pictures/google2.JPG';
import google3 from './posts/22-23/pictures/google3.JPG';
import google4 from './posts/22-23/pictures/google4.JPG';
import google5 from './posts/22-23/pictures/google5.JPG';
import google6 from './posts/22-23/pictures/google6.JPG';
import Fall22MM1group from './posts/22-23/pictures/Fall22MM1group.jpg';
import Fall22MM1talk from './posts/22-23/pictures/Fall22MM1talk.jpg';
import Fall22MM1wait from './posts/22-23/pictures/Fall22MM1wait.jpg';
import events2425year1st from './components/posts/24-25/pictures/Screenshot_2025-06-13_105601.png';
import events2425year2nd from './components/posts/24-25/pictures/Screenshot_2025-06-13_105655.png';
import events2425year3rd from './components/posts/24-25/pictures/Screenshot_2025-06-13_105716.png';
import events2425year4th from './components/posts/24-25/pictures/Screenshot_2025-06-16_102716.png';
import events2425year5th from './components/posts/24-25/pictures/Screenshot_2025-06-16_102809.png';

import wicTeam from './components/posts/25-26/pictures/friendsgiving/wicOfficerTeam.jpeg';
import attendees1 from './components/posts/25-26/pictures/friendsgiving/attendees1.jpeg';
import attendees2 from './components/posts/25-26/pictures/friendsgiving/attendees2.jpeg';
import attendees3 from './components/posts/25-26/pictures/friendsgiving/attendees3.jpeg';
import attendees4 from './components/posts/25-26/pictures/friendsgiving/attendees4.jpeg';
import attendees5 from './components/posts/25-26/pictures/friendsgiving/attendees5.jpeg';
import attendees6 from './components/posts/25-26/pictures/friendsgiving/attendees6.jpeg';
import attendees7 from './components/posts/25-26/pictures/friendsgiving/attendees7.jpeg';
import attendees8 from './components/posts/25-26/pictures/friendsgiving/attendees8.jpeg';
import food from './components/posts/25-26/pictures/friendsgiving/food.jpeg';
import games1 from './components/posts/25-26/pictures/games1.jpeg';
import games2 from './components/posts/25-26/pictures/games2.jpeg';
import mm1 from './components/posts/25-26/pictures/MM1.jpeg';
import tradedesk from './components/posts/25-26/pictures/tradedesk.jpeg';
import attendees from './components/posts/25-26/pictures/tradeDeskAttendees.jpeg';
import matcha from './components/posts/25-26/pictures/matcha.jpeg';
import mm2 from './components/posts/25-26/pictures/MM2.jpeg';
import slides from './components/posts/25-26/pictures/MM2slides.jpeg';

const snapshotsdata = [
  { imgsrc: mm2 }, { imgsrc: slides }, { imgsrc: matcha }, { imgsrc: attendees }, { imgsrc: tradedesk }, 
  { imgsrc: mm1 }, { imgsrc: games1 }, { imgsrc: games2 }, { imgsrc: food }, { imgsrc: attendees8 }, 
  { imgsrc: attendees7 }, { imgsrc: attendees6 }, { imgsrc: attendees5 }, { imgsrc: attendees4 }, 
  { imgsrc: attendees3 }, { imgsrc: attendees2 }, { imgsrc: attendees1 }, { imgsrc: wicTeam },
  { imgsrc: events2425year5th}, { imgsrc: events2425year4th}, { imgsrc: events2425year1st}, 
  { imgsrc: events2425year2nd}, { imgsrc: events2425year3rd}, { imgsrc: wad1 }, { imgsrc: wad2 }, 
  { imgsrc: slumber2 }, { imgsrc: slumber6 }, { imgsrc: dec1 }, { imgsrc: dec7 }, { imgsrc: f1 }, { imgsrc: f3 },
  { imgsrc: ghc3 }, { imgsrc: ghc1 }, { imgsrc: Googlerecap1 }, { imgsrc: Googlerecap6 },
  { imgsrc: Pinterest1 }, { imgsrc: Pinterest2 }, { imgsrc: Uberofficer }, { imgsrc: Uberspeakers },
  { imgsrc: MM1group }, { imgsrc: MM1officer }, { imgsrc: PM1 }, { imgsrc: PM2 },
  { imgsrc: PM3 }, { imgsrc: PM4 }, { imgsrc: bouquet1 }, { imgsrc: bouquet2 },
  { imgsrc: bouquet3 }, { imgsrc: bouquet4 }, { imgsrc: bouquet5 }, { imgsrc: bouquet6 },
  { imgsrc: prep1 }, { imgsrc: prep2 }, { imgsrc: wir1 }, { imgsrc: wir2 },
  { imgsrc: wir3 }, { imgsrc: wad }, { imgsrc: equity1 }, { imgsrc: equity2 },
  { imgsrc: bowl1 }, { imgsrc: bowl2 }, { imgsrc: bowl3 }, { imgsrc: cookies1 },
  { imgsrc: cookies2 }, { imgsrc: google1 }, { imgsrc: google2 }, { imgsrc: google3 },
  { imgsrc: google4 }, { imgsrc: google5 }, { imgsrc: google6 }, { imgsrc: Fall22MM1group },
  { imgsrc: Fall22MM1talk }, { imgsrc: Fall22MM1wait }
];

export default snapshotsdata;
